import { useMemo } from 'react';
import { useFirebase } from './FirebaseContextProvider';
import placeholderTeam from '../assets/images/placeholder-team.png';
import './StandingsTable.scss';

export default function Standings({
  id,
  division,
  gameType,
  title,
  colorLegend,
  rows,
  hideWhenEmpty = false,
}) {
  const { teamsById, standingsByKey } = useFirebase();

  // Explicit rows (e.g. passed by the Live tab) win; otherwise read the
  // backend-computed standings doc from the map
  const sortedStats = useMemo(
    () => rows || standingsByKey.get(`${id}|${division}|${gameType}`)?.rows || [],
    [rows, id, division, gameType, standingsByKey]
  );

  // e.g. the playoff table before any playoff game is scored
  if (hideWhenEmpty && sortedStats.length === 0) return null;

  return (
    <div className='standings-table'>
      <h4>{title}</h4>
      <div className='table'>
        <ul className='header'>
          {['Rank', 'Team', 'GP', 'W', 'L', 'T', 'PF', 'PA', 'Diff'].map(
            (col, i) => (
              <li key={i} className={`col-${i + 1}`}>
                <h6>{col}</h6>
              </li>
            )
          )}
        </ul>
        <div className='body'>
          {sortedStats.map((t, i) => {
            const noGames = t.gamesPlayed === 0;
            const diff = t.pointsFor - t.pointsAgainst;
            const bgColor = `${colorLegend[division]?.color || '000000'}30`;
            return (
              <ul
                className='row'
                key={t.teamId}
              >
                <li className='col-1'>
                  <p
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {i + 1}
                  </p>
                </li>
                <li className='col-2'>
                  <div
                    className='team-cell'
                    style={{ backgroundColor: bgColor }}
                  >
                    <div
                      className='bg-image wh-32'
                      style={{
                        backgroundImage: `url(${teamsById.get(t.teamId)?.imgThumbUrl || placeholderTeam})`,
                      }}
                    />
                    <span>{teamsById.get(t.teamId)?.name || ''}</span>
                  </div>
                </li>
                <li className='col-3'>
                  <p
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {noGames ? '-' : t.gamesPlayed}
                  </p>
                </li>
                <li className='col-4'>
                  <p
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {noGames ? '-' : t.wins}
                  </p>
                </li>
                <li className='col-5'>
                  <p
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {noGames ? '-' : t.losses}
                  </p>
                </li>
                <li className='col-6'>
                  <p
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {noGames ? '-' : t.ties}
                  </p>
                </li>
                <li className='col-7'>
                  <p
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {noGames ? '-' : t.pointsFor}
                  </p>
                </li>
                <li className='col-8'>
                  <p
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {noGames ? '-' : t.pointsAgainst}
                  </p>
                </li>
                <li className='col-9'>
                  <p
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {noGames ? '-' : diff}
                  </p>
                </li>
              </ul>
            );
          })}
        </div>
      </div>
    </div>
  );
}
